import type { ReactElement } from 'react';
import type { User } from '@chatapp-inbox/shared';
import { UserAccessBlock } from './UserAccessBlock';
import { UserBitrixBlock } from './UserBitrixBlock';
import { UserDataForm } from './UserDataForm';
import { UserPasswordForm } from './UserPasswordForm';
import styles from './EditUserPanel.module.css';

interface EditUserPanelProps {
  id: string;
  user: User;
  viewerId: string;
  focusHeading: () => void;
}

/** Edição de um usuário: três blocos independentes (dados, acesso e senha), cada um com o seu envio. */
export function EditUserPanel({
  id,
  user,
  viewerId,
  focusHeading,
}: EditUserPanelProps): ReactElement {
  return (
    <div id={id} className={styles.panel}>
      <UserDataForm user={user} viewerId={viewerId} />
      <UserBitrixBlock user={user} />
      <UserAccessBlock user={user} viewerId={viewerId} focusHeading={focusHeading} />
      <UserPasswordForm user={user} viewerId={viewerId} />
    </div>
  );
}
